module.exports = __webpack_public_path__ + "static/img/12.0876ad7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/12.png
// module id = Fw2k
// module chunks = 0